import React, {useMemo} from "react"
import {Chart} from "react-google-charts"
import ChartHolder from "./ChartHolder"


export default function RescuesChart(params) {

    const {data, subtitle = "po danima i skijalištima", hAxisOptions = {}} = params

    const options = {
        isStacked: true,
        vAxis: {
            title: 'Broj povreda',
            titleTextStyle: {
                fontSize: 12,
                color: "#888",
                italic: false,
                fontName: "Open Sans"
            },
            textStyle: {
                fontSize: 12,
                color: "#888",
                italic: false,
                fontName: "Open Sans"
            }
        },
        hAxis: {
            ...hAxisOptions,
            textStyle: {
                fontSize: 12,
                color: "#888",
                italic: false,
                fontName: "Open Sans"
            }
        },
        chartArea: {
            left: 120, 
            right: 160,
            top: 40,
            bottom: 60
        }
    }
    
    if (!data) return

    return <ChartHolder title="Povrede" subtitle={subtitle} noData={data?.length < 2}>
        <Chart chartType="ColumnChart" width="100%" height="100%" data={data} options={options}/>       
    </ChartHolder>
}